/* @flow */

export default class ActivateOfficeRequest {
    officeId: number;
    companyId: number;
  }
  